import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Modal, Icon } from 'grab-ui';
import {
  INACESSIBLE_LOGIN_MODAL,
  LOGIN_ERRORS,
} from 'constants/login-constant';

import css from '../invalid-token-modal/invalid-token-modal.less';

export default function InacessibleModal({
  isVisibleAccessibleModal,
  closeInaccessbibleModal,
  isAdmin,
  loginErrorType,
}) {
  const renderContentBasedOnRole = () => {
    switch (loginErrorType) {
      case LOGIN_ERRORS.noAssociatedCompany:
        return (
          <h5>
            {I18n.t(INACESSIBLE_LOGIN_MODAL.NO_ASSOCIATED_COMPANY_CONTENT)}
          </h5>
        );
      case LOGIN_ERRORS.noUserFound:
        return <h5>{I18n.t(INACESSIBLE_LOGIN_MODAL.NO_USER_FOUND)}</h5>;
      case LOGIN_ERRORS.isLinkingFailed:
        return isAdmin ? (
          <h5>{I18n.t(INACESSIBLE_LOGIN_MODAL.LINK_FAILED_ADMIN_CONTENT)}</h5>
        ) : (
          <h5> {I18n.t(INACESSIBLE_LOGIN_MODAL.LINK_FAILED_USER_CONTENT)}</h5>
        );
      default:
        return isAdmin ? (
          <h5>
            {I18n.t(INACESSIBLE_LOGIN_MODAL.MISSING_PERMISSION_ADMIN_CONTENT)}
          </h5>
        ) : (
          <h5>
            {I18n.t(INACESSIBLE_LOGIN_MODAL.MISSING_PERMISSION_USER_CONTENT)}
          </h5>
        );
    }
  };

  const getOkText = () =>
    loginErrorType === LOGIN_ERRORS.isLinkingFailed
      ? I18n.t(INACESSIBLE_LOGIN_MODAL.LINK_FAILED_TRY_AGAIN)
      : I18n.t(INACESSIBLE_LOGIN_MODAL.MISSING_PERSSION_OK);

  return (
    <Modal
      visible={isVisibleAccessibleModal}
      onOk={closeInaccessbibleModal}
      okText={getOkText()}
      width={540}
      closable={false}
      maskClosable={false}
      className={css.modal}
    >
      <div className={css.content}>
        <Icon type="exclamation-circle" />
        <div className={css.message}>
          <h4> {I18n.t(INACESSIBLE_LOGIN_MODAL.HEADING)}</h4>
          {renderContentBasedOnRole()}
        </div>
      </div>
    </Modal>
  );
}

InacessibleModal.propTypes = {
  isVisibleAccessibleModal: PropTypes.bool.isRequired,
  closeInaccessbibleModal: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  loginErrorType: PropTypes.string,
};

InacessibleModal.defaultProps = {
  isAdmin: false,
  loginErrorType: '',
};
